// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"845":"6aef0846","1349":"15142834","2812":"6aef0846","3501":"a4fecb55","9876":"aecc4d4c"}[chunkId] + ".chunk.css";
};